var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPizza(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-143"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 345.68,
    rx: 224.27,
    ry: 132.13,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-143"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.84,259.53l-98.27,56.73a12,12,0,0,1-12,0l-58-33.46a3.34,3.34,0,0,1,0-5.78l98.27-56.74a12,12,0,0,1,12,0l58,33.46A3.34,3.34,0,0,1,267.84,259.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.38,
    cy: 392.98,
    rx: 47.28,
    ry: 27.86,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 323.18,
    cy: 385.91,
    rx: 83.88,
    ry: 49.42,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-143"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.12,236.25v73.56h0a2.24,2.24,0,0,0,1.33,1.85,7.08,7.08,0,0,0,6.43,0,2.26,2.26,0,0,0,1.33-1.85V236.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.39,181.62v73.56h0a2.27,2.27,0,0,0,1.33,1.86,7.12,7.12,0,0,0,6.42,0,2.27,2.27,0,0,0,1.33-1.86V181.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.36,204v73.56h0a2.24,2.24,0,0,0,1.33,1.85,7.06,7.06,0,0,0,6.42,0,2.24,2.24,0,0,0,1.33-1.85V204Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.34 215.75 165.39 275.76 99.79 237.89 203.73 177.87 269.34 215.75",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.39 275.76 165.39 282.64 99.79 244.77 99.79 237.89 165.39 275.76",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.34 222.63 165.39 282.64 165.39 275.76 269.34 215.75 269.34 222.63",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.16 182.25 205.48 205.16 175.41 187.67 215.1 164.76 245.16 182.25",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.48 240.72 175.41 223.24 175.41 187.67 205.48 205.16 205.48 240.72",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.16 217.81 205.48 240.72 205.48 205.16 245.16 182.25 245.16 217.81",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.06 200.83 225.76 199.02 219.69 207.4 219.69 197.21 231.06 190.64 231.06 200.83",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.69 197.21 190.12 179.18 202.29 172.16 231.06 190.64 219.69 197.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.34,
    cy: 240.26,
    rx: 31.4,
    ry: 18.13,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.34,
    cy: 239.18,
    rx: 31.4,
    ry: 18.13,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.34,
    cy: 238.42,
    rx: 20.89,
    ry: 12.06,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.34,
    cy: 235.13,
    rx: 31.4,
    ry: 18.13,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.34,
    cy: 234.05,
    rx: 31.4,
    ry: 18.13,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.34,
    cy: 233.29,
    rx: 20.89,
    ry: 12.06,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.55,242.82c-12.27,7.08-32.15,7.08-44.41,0s-12.26-18.56,0-25.64,32.14-7.08,44.41,0S191.81,235.74,179.55,242.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.34,
    cy: 228.92,
    rx: 31.4,
    ry: 18.13,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.34,
    cy: 228.16,
    rx: 20.89,
    ry: 12.06,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.34,
    cy: 224.87,
    rx: 31.4,
    ry: 18.13,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.34,
    cy: 223.79,
    rx: 31.4,
    ry: 18.13,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.34,
    cy: 223.03,
    rx: 20.89,
    ry: 12.06,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.34,
    cy: 219.74,
    rx: 31.4,
    ry: 18.13,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.34,
    cy: 218.66,
    rx: 31.4,
    ry: 18.13,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.34,
    cy: 217.9,
    rx: 20.89,
    ry: 12.06,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.36,163.06v73.55h0a2.26,2.26,0,0,0,1.33,1.86,7.12,7.12,0,0,0,6.42,0,2.26,2.26,0,0,0,1.33-1.86V163.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.39,140.71v73.56h0a2.24,2.24,0,0,0,1.33,1.85,7.12,7.12,0,0,0,6.42,0,2.24,2.24,0,0,0,1.33-1.85V140.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.12,195.34v73.55h0a2.26,2.26,0,0,0,1.33,1.86,7.14,7.14,0,0,0,6.43,0,2.28,2.28,0,0,0,1.33-1.86V195.34Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.34 141.3 165.39 201.31 99.79 163.43 203.73 103.42 269.34 141.3",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.39 201.31 165.39 208.19 99.79 170.31 99.79 163.43 165.39 201.31",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.34 148.18 165.39 208.19 165.39 201.31 269.34 141.3 269.34 148.18",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ingredients--inject-143"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.48,115.72a3.59,3.59,0,0,0,.9.25,14.45,14.45,0,0,1,5.3,1.65l1.69,1a2.07,2.07,0,0,0,2.63-.41,2,2,0,0,0-.54-3l-1.57-.9a12.25,12.25,0,0,1-4.15-3.68,3.48,3.48,0,0,0-6.24,2.89A3.39,3.39,0,0,0,201.48,115.72Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.14,142.77,247,131l-33.36-20.09h0a3.33,3.33,0,0,0-3.45.3,10.63,10.63,0,0,0-4.81,8.34,3.44,3.44,0,0,0,1.33,3.06h0l0,0,.1,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.14,142.77,247,131l-33.36-20.09h0a3.33,3.33,0,0,0-3.45.3,10.63,10.63,0,0,0-4.81,8.34,3.44,3.44,0,0,0,1.33,3.06h0l0,0,.1,0Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.37,134.11a10.64,10.64,0,0,1-4.81,8.34c-2.66,1.53-4.82.29-4.82-2.78a10.64,10.64,0,0,1,4.82-8.34C246.22,129.79,248.37,131,248.37,134.11Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.62,138.39a4.06,4.06,0,0,0-.9-.25,14.57,14.57,0,0,1-5.29-1.64l-1.7-1a2.07,2.07,0,0,0-2.63.4,2,2,0,0,0,.54,3l1.57.91a12,12,0,0,1,4.15,3.68,3.45,3.45,0,0,0,2.89,1.56,3.49,3.49,0,0,0,3.36-4.45A3.42,3.42,0,0,0,253.62,138.39Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.62,138.39a4.06,4.06,0,0,0-.9-.25,14.57,14.57,0,0,1-5.29-1.64l-1.7-1a2.07,2.07,0,0,0-2.63.4,2,2,0,0,0,.54,3l1.57.91a12,12,0,0,1,4.15,3.68,3.45,3.45,0,0,0,2.89,1.56,3.49,3.49,0,0,0,3.36-4.45A3.42,3.42,0,0,0,253.62,138.39Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,131.29a17.33,17.33,0,0,0-1.9,1.52c-3.25,3-5.8,8.6-4,13,1.76,4.22,6.63,5.81,10.78,6.38,4,.54,8.3.7,11.54,3.09,1.65,1.23,2.9,3,4.66,4a9.61,9.61,0,0,0,7.67.64,20.43,20.43,0,0,0,6.78-4c2.71-2.22,5.24-4.86,6.39-8.17,1.7-4.89,0-10.55-3.55-14.36-6.68-7.22-17.49-7.56-26.61-6.28A27.29,27.29,0,0,0,178,131.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,131.29a17.33,17.33,0,0,0-1.9,1.52c-3.25,3-5.8,8.6-4,13,1.76,4.22,6.63,5.81,10.78,6.38,4,.54,8.3.7,11.54,3.09,1.65,1.23,2.9,3,4.66,4a9.61,9.61,0,0,0,7.67.64,20.43,20.43,0,0,0,6.78-4c2.71-2.22,5.24-4.86,6.39-8.17,1.7-4.89,0-10.55-3.55-14.36-6.68-7.22-17.49-7.56-26.61-6.28A27.29,27.29,0,0,0,178,131.29Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.92,144.9c-1.15,3.31-3.68,5.95-6.39,8.17a20.43,20.43,0,0,1-6.78,4,9.61,9.61,0,0,1-7.67-.64c-1.76-1-3-2.78-4.66-4-3.24-2.4-7.55-2.56-11.54-3.1-4.15-.57-9-2.15-10.78-6.38a8.08,8.08,0,0,1-.5-1.79,8.92,8.92,0,0,0,.5,4.67c1.76,4.22,6.63,5.81,10.78,6.38,4,.54,8.3.7,11.54,3.09,1.65,1.23,2.9,3,4.66,4a9.61,9.61,0,0,0,7.67.64,20.43,20.43,0,0,0,6.78-4c2.71-2.22,5.24-4.86,6.39-8.17a12.47,12.47,0,0,0,.58-5.45A11.51,11.51,0,0,1,219.92,144.9Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.92,144.9c-1.15,3.31-3.68,5.95-6.39,8.17a20.43,20.43,0,0,1-6.78,4,9.61,9.61,0,0,1-7.67-.64c-1.76-1-3-2.78-4.66-4-3.24-2.4-7.55-2.56-11.54-3.1-4.15-.57-9-2.15-10.78-6.38a8.08,8.08,0,0,1-.5-1.79,8.92,8.92,0,0,0,.5,4.67c1.76,4.22,6.63,5.81,10.78,6.38,4,.54,8.3.7,11.54,3.09,1.65,1.23,2.9,3,4.66,4a9.61,9.61,0,0,0,7.67.64,20.43,20.43,0,0,0,6.78-4c2.71-2.22,5.24-4.86,6.39-8.17a12.47,12.47,0,0,0,.58-5.45A11.51,11.51,0,0,1,219.92,144.9Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,143.4a1.61,1.61,0,0,0,1.08.45c.79,0,1.19-1,1.14-1.78a13.25,13.25,0,0,1-.29-2.33c.17-1.46,1.74-2.65.9-4.19-1-1.75-2.65-1-3.64.24A5.6,5.6,0,0,0,179,143.4Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,143.4a1.61,1.61,0,0,0,1.08.45c.79,0,1.19-1,1.14-1.78a13.25,13.25,0,0,1-.29-2.33c.17-1.46,1.74-2.65.9-4.19-1-1.75-2.65-1-3.64.24A5.6,5.6,0,0,0,179,143.4Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.37,139a1.23,1.23,0,0,0-1.42.28,1.6,1.6,0,0,0-.32,1.46,1.81,1.81,0,0,0,2,1.29,1.66,1.66,0,0,0,1.31-1.9,1.53,1.53,0,0,0-2-1",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.37,139a1.23,1.23,0,0,0-1.42.28,1.6,1.6,0,0,0-.32,1.46,1.81,1.81,0,0,0,2,1.29,1.66,1.66,0,0,0,1.31-1.9,1.53,1.53,0,0,0-2-1",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.59,149a3.81,3.81,0,0,1-1.89,1.74c-.75.33-1.67.43-2.19,1.07a1.87,1.87,0,0,0,.23,2.4,2.77,2.77,0,0,0,2.45.64,5.79,5.79,0,0,0,2.35-1.14c1.59-1.18,5.49-5.36,4-7.66C210.66,143.2,208.22,147.76,207.59,149Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.59,149a3.81,3.81,0,0,1-1.89,1.74c-.75.33-1.67.43-2.19,1.07a1.87,1.87,0,0,0,.23,2.4,2.77,2.77,0,0,0,2.45.64,5.79,5.79,0,0,0,2.35-1.14c1.59-1.18,5.49-5.36,4-7.66C210.66,143.2,208.22,147.76,207.59,149Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.5,
    cy: 149.2,
    rx: 10.74,
    ry: 8.08,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.5,
    cy: 149.2,
    rx: 10.74,
    ry: 8.08,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.46 140.05 156.58 138.77 156.3 140.81 153.34 141.23 155.38 142.01 154.47 144.19 156.65 143.2 158.27 145.25 158.84 143.13 161.51 143.49 160.38 141.87 161.3 139.55 158.46 140.05",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.28,158.4a5.06,5.06,0,0,0-2.68-.93,4.44,4.44,0,0,0-2.46,8.14.43.43,0,0,0,.1.09h0l.06,0,14.15,8.32,4.47-7.64S136.3,160.88,132.28,158.4Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.28,158.4a5.06,5.06,0,0,0-2.68-.93,4.44,4.44,0,0,0-2.46,8.14.43.43,0,0,0,.1.09h0l.06,0,14.15,8.32,4.47-7.64S136.3,160.88,132.28,158.4Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.81,168.44a6.92,6.92,0,0,1-3.13,5.42c-1.73,1-3.13.19-3.13-1.81a6.91,6.91,0,0,1,3.13-5.42C145.41,165.63,146.81,166.44,146.81,168.44Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.81,168.44a6.92,6.92,0,0,1-3.13,5.42c-1.73,1-3.13.19-3.13-1.81a6.91,6.91,0,0,1,3.13-5.42C145.41,165.63,146.81,166.44,146.81,168.44Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.64,167.78a1.24,1.24,0,0,1-.54.94c-.3.17-.55,0-.55-.32a1.19,1.19,0,0,1,.55-.93C145.39,167.29,145.64,167.43,145.64,167.78Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.64,167.78a1.24,1.24,0,0,1-.54.94c-.3.17-.55,0-.55-.32a1.19,1.19,0,0,1,.55-.93C145.39,167.29,145.64,167.43,145.64,167.78Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.78,168.85a.71.71,0,0,1-.34.58c-.18.11-.33,0-.33-.19a.76.76,0,0,1,.33-.58C143.63,168.55,143.78,168.64,143.78,168.85Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.78,168.85a.71.71,0,0,1-.34.58c-.18.11-.33,0-.33-.19a.76.76,0,0,1,.33-.58C143.63,168.55,143.78,168.64,143.78,168.85Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.2,170.73a.73.73,0,0,1-.33.58c-.19.11-.34,0-.34-.19a.74.74,0,0,1,.34-.58C145.05,170.43,145.2,170.52,145.2,170.73Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.2,170.73a.73.73,0,0,1-.33.58c-.19.11-.34,0-.34-.19a.74.74,0,0,1,.34-.58C145.05,170.43,145.2,170.52,145.2,170.73Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.74,172.59a.51.51,0,0,1-.25.42c-.13.08-.24,0-.24-.14a.56.56,0,0,1,.24-.42C143.63,172.38,143.74,172.44,143.74,172.59Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.74,172.59a.51.51,0,0,1-.25.42c-.13.08-.24,0-.24-.14a.56.56,0,0,1,.24-.42C143.63,172.38,143.74,172.44,143.74,172.59Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.69,170.81a.51.51,0,0,1-.25.42c-.13.08-.24,0-.24-.14a.56.56,0,0,1,.24-.42C143.58,170.6,143.69,170.66,143.69,170.81Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.69,170.81a.51.51,0,0,1-.25.42c-.13.08-.24,0-.24-.14a.56.56,0,0,1,.24-.42C143.58,170.6,143.69,170.66,143.69,170.81Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.93,171.55a.54.54,0,0,1-.24.42c-.13.08-.24,0-.24-.14a.56.56,0,0,1,.24-.42C141.82,171.33,141.93,171.4,141.93,171.55Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.93,171.55a.54.54,0,0,1-.24.42c-.13.08-.24,0-.24-.14a.56.56,0,0,1,.24-.42C141.82,171.33,141.93,171.4,141.93,171.55Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.48,169a8.83,8.83,0,0,1-8,0c-2.2-1.27-2.2-3.34,0-4.62a8.9,8.9,0,0,1,8,0C163.69,165.63,163.69,167.7,161.48,169Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.48,169a8.83,8.83,0,0,1-8,0c-2.2-1.27-2.2-3.34,0-4.62a8.9,8.9,0,0,1,8,0C163.69,165.63,163.69,167.7,161.48,169Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.48,168.36a8.83,8.83,0,0,1-8,0c-2.2-1.28-2.2-3.35,0-4.62a8.83,8.83,0,0,1,8,0C163.69,165,163.69,167.08,161.48,168.36Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.48,168.36a8.83,8.83,0,0,1-8,0c-2.2-1.28-2.2-3.35,0-4.62a8.83,8.83,0,0,1,8,0C163.69,165,163.69,167.08,161.48,168.36Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.19,164.75a.91.91,0,0,1-.85,0c-.23-.13-.23-.35,0-.49a1,1,0,0,1,.85,0C155.42,164.4,155.42,164.62,155.19,164.75Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.19,164.75a.91.91,0,0,1-.85,0c-.23-.13-.23-.35,0-.49a1,1,0,0,1,.85,0C155.42,164.4,155.42,164.62,155.19,164.75Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.96,
    cy: 167.53,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.96,
    cy: 167.53,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.71,165.8a.53.53,0,0,1-.49,0c-.14-.08-.14-.21,0-.28a.53.53,0,0,1,.49,0C153.85,165.59,153.85,165.72,153.71,165.8Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.71,165.8a.53.53,0,0,1-.49,0c-.14-.08-.14-.21,0-.28a.53.53,0,0,1,.49,0C153.85,165.59,153.85,165.72,153.71,165.8Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.46,166.57a.53.53,0,0,1-.49,0c-.14-.08-.14-.2,0-.28a.53.53,0,0,1,.49,0C157.6,166.37,157.6,166.49,157.46,166.57Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.46,166.57a.53.53,0,0,1-.49,0c-.14-.08-.14-.2,0-.28a.53.53,0,0,1,.49,0C157.6,166.37,157.6,166.49,157.46,166.57Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 158.37,
    cy: 165.34,
    rx: 0.35,
    ry: 0.2,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 158.37,
    cy: 165.34,
    rx: 0.35,
    ry: 0.2,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.61,167.49a.6.6,0,0,1-.49,0,.15.15,0,0,1,0-.29.53.53,0,0,1,.49,0A.15.15,0,0,1,155.61,167.49Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.61,167.49a.6.6,0,0,1-.49,0,.15.15,0,0,1,0-.29.53.53,0,0,1,.49,0A.15.15,0,0,1,155.61,167.49Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.91,168a.53.53,0,0,1-.49,0,.15.15,0,0,1,0-.29.6.6,0,0,1,.49,0A.15.15,0,0,1,159.91,168Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.91,168a.53.53,0,0,1-.49,0,.15.15,0,0,1,0-.29.6.6,0,0,1,.49,0A.15.15,0,0,1,159.91,168Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.05,164.79a.53.53,0,0,1-.49,0,.15.15,0,0,1,0-.28.53.53,0,0,1,.49,0C161.19,164.59,161.19,164.71,161.05,164.79Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.05,164.79a.53.53,0,0,1-.49,0,.15.15,0,0,1,0-.28.53.53,0,0,1,.49,0C161.19,164.59,161.19,164.71,161.05,164.79Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.88,166a8.81,8.81,0,0,1-8,0c-2.21-1.27-2.21-3.34,0-4.62a8.88,8.88,0,0,1,8,0C159.09,162.69,159.09,164.76,156.88,166Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.88,166a8.81,8.81,0,0,1-8,0c-2.21-1.27-2.21-3.34,0-4.62a8.88,8.88,0,0,1,8,0C159.09,162.69,159.09,164.76,156.88,166Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.88,165.42a8.88,8.88,0,0,1-8,0c-2.21-1.28-2.21-3.35,0-4.62a8.81,8.81,0,0,1,8,0C159.09,162.07,159.09,164.14,156.88,165.42Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.88,165.42a8.88,8.88,0,0,1-8,0c-2.21-1.28-2.21-3.35,0-4.62a8.81,8.81,0,0,1,8,0C159.09,162.07,159.09,164.14,156.88,165.42Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.59,161.81a.89.89,0,0,1-.84,0c-.24-.13-.24-.35,0-.49a1,1,0,0,1,.84,0C150.83,161.46,150.83,161.68,150.59,161.81Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.59,161.81a.89.89,0,0,1-.84,0c-.24-.13-.24-.35,0-.49a1,1,0,0,1,.84,0C150.83,161.46,150.83,161.68,150.59,161.81Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.79,164.83a.89.89,0,0,1-.84,0c-.24-.13-.24-.35,0-.48a.89.89,0,0,1,.84,0C154,164.48,154,164.7,153.79,164.83Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.79,164.83a.89.89,0,0,1-.84,0c-.24-.13-.24-.35,0-.48a.89.89,0,0,1,.84,0C154,164.48,154,164.7,153.79,164.83Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.87,
    cy: 162.72,
    rx: 0.35,
    ry: 0.2,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.87,
    cy: 162.72,
    rx: 0.35,
    ry: 0.2,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.87,163.63a.55.55,0,0,1-.5,0,.15.15,0,0,1,0-.28.55.55,0,0,1,.5,0A.15.15,0,0,1,152.87,163.63Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.87,163.63a.55.55,0,0,1-.5,0,.15.15,0,0,1,0-.28.55.55,0,0,1,.5,0A.15.15,0,0,1,152.87,163.63Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,162.54a.53.53,0,0,1-.49,0,.15.15,0,0,1,0-.29.6.6,0,0,1,.49,0A.15.15,0,0,1,154,162.54Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,162.54a.53.53,0,0,1-.49,0,.15.15,0,0,1,0-.29.6.6,0,0,1,.49,0A.15.15,0,0,1,154,162.54Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,164.54a.55.55,0,0,1-.5,0c-.13-.07-.13-.2,0-.28a.55.55,0,0,1,.5,0C151.15,164.34,151.15,164.47,151,164.54Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,164.54a.55.55,0,0,1-.5,0c-.13-.07-.13-.2,0-.28a.55.55,0,0,1,.5,0C151.15,164.34,151.15,164.47,151,164.54Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.07,
    cy: 164.94,
    rx: 0.35,
    ry: 0.2,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.07,
    cy: 164.94,
    rx: 0.35,
    ry: 0.2,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.46,161.85a.53.53,0,0,1-.49,0c-.14-.08-.14-.21,0-.28a.53.53,0,0,1,.49,0C156.6,161.64,156.6,161.77,156.46,161.85Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.46,161.85a.53.53,0,0,1-.49,0c-.14-.08-.14-.21,0-.28a.53.53,0,0,1,.49,0C156.6,161.64,156.6,161.77,156.46,161.85Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.57,
    cy: 161.53,
    rx: 5.66,
    ry: 3.27,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.57,
    cy: 161.53,
    rx: 5.66,
    ry: 3.27,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.57,
    cy: 160.91,
    rx: 5.66,
    ry: 3.27,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.57,
    cy: 160.91,
    rx: 5.66,
    ry: 3.27,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.28,159.62a1,1,0,0,1-.84,0c-.23-.14-.23-.36,0-.49a.89.89,0,0,1,.84,0C146.52,159.26,146.52,159.48,146.28,159.62Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.28,159.62a1,1,0,0,1-.84,0c-.23-.14-.23-.36,0-.49a.89.89,0,0,1,.84,0C146.52,159.26,146.52,159.48,146.28,159.62Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.06,
    cy: 162.4,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.06,
    cy: 162.4,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.81,160.67a.62.62,0,0,1-.5,0,.16.16,0,0,1,0-.29.55.55,0,0,1,.5,0A.16.16,0,0,1,144.81,160.67Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.81,160.67a.62.62,0,0,1-.5,0,.16.16,0,0,1,0-.29.55.55,0,0,1,.5,0A.16.16,0,0,1,144.81,160.67Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.56,161.44a.55.55,0,0,1-.5,0,.16.16,0,0,1,0-.29.55.55,0,0,1,.5,0A.16.16,0,0,1,148.56,161.44Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.56,161.44a.55.55,0,0,1-.5,0,.16.16,0,0,1,0-.29.55.55,0,0,1,.5,0A.16.16,0,0,1,148.56,161.44Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.71,160.34a.53.53,0,0,1-.49,0c-.14-.07-.14-.2,0-.28a.53.53,0,0,1,.49,0C149.85,160.14,149.85,160.27,149.71,160.34Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.71,160.34a.53.53,0,0,1-.49,0c-.14-.07-.14-.2,0-.28a.53.53,0,0,1,.49,0C149.85,160.14,149.85,160.27,149.71,160.34Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.71,162.35a.55.55,0,0,1-.5,0c-.13-.08-.13-.21,0-.28a.55.55,0,0,1,.5,0C146.84,162.14,146.84,162.27,146.71,162.35Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.71,162.35a.55.55,0,0,1-.5,0c-.13-.08-.13-.21,0-.28a.55.55,0,0,1,.5,0C146.84,162.14,146.84,162.27,146.71,162.35Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 150.76,
    cy: 162.74,
    rx: 0.35,
    ry: 0.2,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 150.76,
    cy: 162.74,
    rx: 0.35,
    ry: 0.2,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.15,159.66a.53.53,0,0,1-.49,0,.15.15,0,0,1,0-.29.53.53,0,0,1,.49,0A.15.15,0,0,1,152.15,159.66Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.15,159.66a.53.53,0,0,1-.49,0,.15.15,0,0,1,0-.29.53.53,0,0,1,.49,0A.15.15,0,0,1,152.15,159.66Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.43,183c-3.61,2.08-11,1.2-11,1.2s-1.53-4.27,2.07-6.35,11-1.21,11-1.21S178,180.94,174.43,183Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.43,183c-3.61,2.08-11,1.2-11,1.2s-1.53-4.27,2.07-6.35,11-1.21,11-1.21S178,180.94,174.43,183Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.43,183c-3.61,2.08-11,1.2-11,1.2l13.08-7.56S178,180.94,174.43,183Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.43,183c-3.61,2.08-11,1.2-11,1.2l13.08-7.56S178,180.94,174.43,183Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.23,175.15c.14,4.17-4.12,10.27-4.12,10.27s-4.49-.65-4.63-4.82,4.12-10.28,4.12-10.28S167.09,171,167.23,175.15Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.23,175.15c.14,4.17-4.12,10.27-4.12,10.27s-4.49-.65-4.63-4.82,4.12-10.28,4.12-10.28S167.09,171,167.23,175.15Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.23,175.15c.14,4.17-4.12,10.27-4.12,10.27l-.51-15.1S167.09,171,167.23,175.15Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.23,175.15c.14,4.17-4.12,10.27-4.12,10.27l-.51-15.1S167.09,171,167.23,175.15Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,168.81a5.78,5.78,0,0,0-2.47,2.47c-.63,1.36-3.59,1.84-5.32.83l-.17-.1c-3.4-2.08-3.43-5.43-.06-7.53,3.7-2.3,9.95-2.36,13.76-.15l.05,0c1.69,1,.81,2.68-1.51,3A12.35,12.35,0,0,0,182,168.81Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.76,168.79l1.61-.93,1.61-.93,6.91,2.63c1,.38,1.13,1.19.29,1.68l-1.48.85-1.47.85a2.85,2.85,0,0,1-2.91-.16Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182,168.81a5.78,5.78,0,0,0-2.47,2.47c-.63,1.36-3.59,1.84-5.32.83l-.17-.1c-3.4-2.08-3.43-5.43-.06-7.53,3.7-2.3,9.95-2.36,13.76-.15l.05,0c1.69,1,.81,2.68-1.51,3A12.35,12.35,0,0,0,182,168.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.76,168.79l1.61-.93,1.61-.93,6.91,2.63c1,.38,1.13,1.19.29,1.68l-1.48.85-1.47.85a2.85,2.85,0,0,1-2.91-.16Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182,167.3a5.82,5.82,0,0,0-2.47,2.46c-.63,1.37-3.59,1.84-5.32.84l-.17-.1c-3.4-2.09-3.43-5.43-.06-7.53,3.7-2.31,9.95-2.36,13.76-.16l.05,0c1.69,1,.81,2.68-1.51,3A12.36,12.36,0,0,0,182,167.3Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.76,167.28l1.61-.93,1.61-.94,6.91,2.64c1,.38,1.13,1.19.29,1.68l-1.48.85-1.47.85a2.82,2.82,0,0,1-2.91-.17Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182,167.3a5.82,5.82,0,0,0-2.47,2.46c-.63,1.37-3.59,1.84-5.32.84l-.17-.1c-3.4-2.09-3.43-5.43-.06-7.53,3.7-2.31,9.95-2.36,13.76-.16l.05,0c1.69,1,.81,2.68-1.51,3A12.36,12.36,0,0,0,182,167.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.76,167.28l1.61-.93,1.61-.94,6.91,2.64c1,.38,1.13,1.19.29,1.68l-1.48.85-1.47.85a2.82,2.82,0,0,1-2.91-.17Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182.76,165.08a5.82,5.82,0,0,0-2.47,2.46c-.63,1.37-3.59,1.84-5.31.84l-.18-.1c-3.4-2.09-3.43-5.43-.06-7.53,3.7-2.31,9.95-2.36,13.76-.15l.05,0c1.69,1,.81,2.68-1.51,3A12.36,12.36,0,0,0,182.76,165.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.5,165.06l1.61-.93,1.61-.93,6.91,2.63c1,.38,1.13,1.19.29,1.68l-1.48.85-1.47.85a2.82,2.82,0,0,1-2.91-.17Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.76,165.08a5.82,5.82,0,0,0-2.47,2.46c-.63,1.37-3.59,1.84-5.31.84l-.18-.1c-3.4-2.09-3.43-5.43-.06-7.53,3.7-2.31,9.95-2.36,13.76-.15l.05,0c1.69,1,.81,2.68-1.51,3A12.36,12.36,0,0,0,182.76,165.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.5,165.06l1.61-.93,1.61-.93,6.91,2.63c1,.38,1.13,1.19.29,1.68l-1.48.85-1.47.85a2.82,2.82,0,0,1-2.91-.17Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182.76,163.57a5.77,5.77,0,0,0-2.47,2.46c-.63,1.36-3.59,1.84-5.31.84l-.18-.11c-3.4-2.08-3.43-5.42-.06-7.52,3.7-2.31,9.95-2.36,13.76-.16l.05,0c1.69,1,.81,2.67-1.51,3A12.36,12.36,0,0,0,182.76,163.57Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.5,163.54l1.61-.93,1.61-.93,6.91,2.64c1,.38,1.13,1.19.29,1.67l-1.48.86-1.47.85a2.85,2.85,0,0,1-2.91-.17Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.76,163.57a5.77,5.77,0,0,0-2.47,2.46c-.63,1.36-3.59,1.84-5.31.84l-.18-.11c-3.4-2.08-3.43-5.42-.06-7.52,3.7-2.31,9.95-2.36,13.76-.16l.05,0c1.69,1,.81,2.67-1.51,3A12.36,12.36,0,0,0,182.76,163.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.5,163.54l1.61-.93,1.61-.93,6.91,2.64c1,.38,1.13,1.19.29,1.67l-1.48.86-1.47.85a2.85,2.85,0,0,1-2.91-.17Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Orders--inject-143"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "193.41 23.08 88.58 83.61 90.39 84.72 195.22 24.2 193.41 23.08",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.39 84.72 88.58 83.61 88.58 125.82 90.39 126.94 90.39 84.72",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.22 24.2 90.39 84.72 90.39 126.94 195.22 66.41 195.22 24.2",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.76 101.65 106.89 112.54 106.89 90.75 125.76 79.86 125.76 101.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.76 79.86 128.66 101.65 109.79 112.54 106.89 90.75 125.76 79.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.85 86.99 116.33 85.99 113.81 89.9 113.81 82.77 118.85 79.86 118.85 86.99",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.86,97.68a.52.52,0,0,1-.44-.25.5.5,0,0,1,.19-.68l10.77-6.22a.5.5,0,1,1,.5.86l-10.77,6.22A.47.47,0,0,1,111.86,97.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.39,101.8a.5.5,0,0,1-.25-.93l10.77-6.22a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-10.77,6.22A.54.54,0,0,1,112.39,101.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.15 65.56 164.28 76.45 164.28 54.66 183.15 43.77 183.15 65.56",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.15 43.77 186.05 65.56 167.18 76.45 164.28 54.66 183.15 43.77",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.23 50.9 173.71 49.9 171.19 53.81 171.19 46.68 176.23 43.77 176.23 50.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.24,61.59a.5.5,0,0,1-.25-.93l10.77-6.22a.51.51,0,0,1,.69.18.52.52,0,0,1-.19.69l-10.77,6.21A.45.45,0,0,1,169.24,61.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.78,65.72a.52.52,0,0,1-.44-.25.52.52,0,0,1,.19-.69l10.77-6.22a.51.51,0,0,1,.68.19.49.49,0,0,1-.18.68L170,65.65A.59.59,0,0,1,169.78,65.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.05 78.48 132.18 89.38 132.18 67.59 151.05 56.69 151.05 78.48",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.05 56.69 153.95 78.48 135.08 89.38 132.18 67.59 151.05 56.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.13 63.83 141.61 62.83 139.09 66.74 139.09 59.6 144.13 56.69 144.13 63.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.15,74.51a.5.5,0,0,1-.25-.93l10.77-6.22a.49.49,0,0,1,.68.19.5.5,0,0,1-.18.68L137.4,74.45A.57.57,0,0,1,137.15,74.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.68,78.64a.5.5,0,0,1-.25-.93l10.77-6.22a.5.5,0,0,1,.5.86l-10.77,6.22A.47.47,0,0,1,137.68,78.64Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-143"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "96.98 368.64 96.98 382.81 107.86 382.81 108.98 368.71 96.98 368.64",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.04 360.21 133.04 374.38 143.92 374.38 145.04 360.28 133.04 360.21",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.23,248.18s6.54,49,9.9,58.07c0,0-3.56,5.27-1.85,19.55s5.22,40.66,5.22,40.66a21.61,21.61,0,0,0,16.72-2L147.54,242Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.06,252a39.9,39.9,0,0,1-11,13.67l-5.44,18.72,2.64-20.5Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.06,252a39.9,39.9,0,0,1-11,13.67l-5.44,18.72,2.64-20.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.64,244.06a276.12,276.12,0,0,0-1.86,31.12c0,16.08,0,27.95,0,27.95a45.16,45.16,0,0,0-3.39,15.42c-.19,8.19-.43,54-.43,54a16.22,16.22,0,0,0,17.28,0l14-108.64s14.46-5.77,15.26-17.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,380.19a4.15,4.15,0,0,0,2,2.27c.86.35-.41-2.42,2-2.84s7.66-.54,7.66,1.43v2.46a14.23,14.23,0,0,0,1.66,6.67,29.59,29.59,0,0,0,3.81,5.85c2.4,2.5,6,8-.86,10.38s-13.48-2.57-13.91-7.19S97.7,393,97.1,392.1A8.4,8.4,0,0,1,95,386.61a46.37,46.37,0,0,1,.55-5.93A2.2,2.2,0,0,1,97,378.93h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.27,406.41c-6.88,2.35-13.48-2.57-13.91-7.19S97.7,393,97.1,392.1A8.74,8.74,0,0,1,95,387.51l-.06.36c-.65,3.76,1.42,5.17,2,6.06s1.58,2.37,2,7,7.38,9.09,14.26,6.74c3.34-1.14,4.2-3,3.93-5C117,404.17,115.88,405.52,113.27,406.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.28,370.89l-.35-1.05a1.58,1.58,0,0,0-2-1l-5.16,1.59a1.58,1.58,0,0,0-1.11,1.51v.52a.93.93,0,0,1-.93.92h0a4.69,4.69,0,0,1-3-1.08l-.72-.59v-1.8h0a3.18,3.18,0,0,0-1.43,2.82c.06,1.22.12,2.71.07,3.3-.08,1.08-1.09,5.59.12,6.92s3.9,1.5,7.24,1.13,7,2.93,10.1,4.15,15.93,3.85,15.9-4.36c0-2.08-2.08-2.94-4.1-3.68s-9.36-3.32-11.23-4.87a17.07,17.07,0,0,1-2.09-2.06A6.87,6.87,0,0,1,146.28,370.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.14,388.21c-3.09-1.22-6.75-4.51-10.1-4.15s-6,.21-7.24-1.13a3.06,3.06,0,0,1-.57-1.89,4.56,4.56,0,0,0,.57,3.07c1.2,1.33,3.9,1.49,7.24,1.13s7,2.93,10.1,4.14,15.93,3.85,15.9-4.35a2.08,2.08,0,0,0,0-.36C164.18,391.87,152.13,389.39,149.14,388.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.91,215.18s26.52,33.59,27.58,34.75,4.17,3.93,4.73,8.23,1,13.31-3.61,13-8.59-3.56-8.37-5.19-.07-10.63-.07-10.63l-29.08-26.46v-11S151.05,213.4,154.91,215.18Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.71,170.23s10.71-3.12,13.9,14.73,4.61,26.23,4.61,26.23l-10.38,2Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.71,170.23s10.71-3.12,13.9,14.73,4.61,26.23,4.61,26.23l-10.38,2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.24,207.06s1.68-1.34,6-1.85l.08.06a4.53,4.53,0,0,1,1.9,3.07l1,6.66-.63,1-.61-.81s-5.33.57-7.95,3.67Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.24,207.06s1.68-1.34,6-1.85l.08.06a4.53,4.53,0,0,1,1.9,3.07l1,6.66-.63,1-.61-.81s-5.33.57-7.95,3.67Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.8,126.62s10.54,4.25,4.91,20.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.54,157.31v12.91s8,11.08,14.52,11.08V164.81Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.15,159.76c1.63,4.36,6.88,7.68,11.91,9.26v-3.9l-12.22-6.31C117.94,159.14,118,159.47,118.15,159.76Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,172.46s-11.71.92-12.93,1.13-4,28.28-4,28.28,5.26,18.3,5.26,20.59-1.72,21.6-1.72,21.6a51.26,51.26,0,0,0,34.57,4.64C146,246.3,147.54,242,147.54,242V213.17c0-14-1.1-36.1-11.83-42.94l-6.6.68-.72,4Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.14,200.79c-1-15.59-2-20.34-2-20.54l-.06-.27-6.38-2.37-.34.94,5.85,2.18c.22,1.2,1.09,6.62,1.95,20.12s1.27,39.45,1.36,45.87l1-.47C142.39,239.18,142,214.13,141.14,200.79Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.14,200.79c-1-15.59-2-20.34-2-20.54l-.06-.27-6.38-2.37-.34.94,5.85,2.18c.22,1.2,1.09,6.62,1.95,20.12s1.27,39.45,1.36,45.87l1-.47C142.39,239.18,142,214.13,141.14,200.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.54,164.51s2.11,3,8.92,3.93l3.8,5a38.42,38.42,0,0,0,.66-5.57h0a1.89,1.89,0,0,0,1.11-1.73v-1h1.84v5.16s-.16,6.54-6.87,6.54a16.65,16.65,0,0,1-11-4.36v-7.31a2.87,2.87,0,0,1,1.54-2.19Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,167.47s6.47,8.72,14.39,8.72c2.71,0,3.51-7.77,3.51-7.77v-3.3s3.24,1.27,2.14,7.9-11.24,7.65-18.8,2.86C110.22,172.69,112,167.47,114,167.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.77,177.75s-3.65-.22-4.63,2.79-.73,3.92-.73,3.92,4.62-1.27,5.61-2.85a4.69,4.69,0,0,0,.68-2,1.9,1.9,0,0,0-.93-1.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.8,176.47s2.37-2.36,4.87-.89,2.89,2.26,2.89,2.26-4,1.92-5.59,1.44a4.39,4.39,0,0,1-1.71-1,1.74,1.74,0,0,1-.46-1.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.49,128.69c4.67,0,13.51,1.93,14.27,12.64s.29,24-8.67,24.78c-6.22.52-17.56-4-20.19-11.05S111.56,128.69,128.49,128.69Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.29 147.08 133.29 154.78 137.8 153.4 133.29 147.08",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.7,148.42a1.57,1.57,0,1,0,1.57-1.57A1.57,1.57,0,0,0,126.7,148.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,147.32a1.57,1.57,0,1,0,1.57-1.57A1.57,1.57,0,0,0,137,147.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.5,144.05l-3.06-1.82s1.17-1.22,2.34-.49A2.13,2.13,0,0,1,140.5,144.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.45,143.53l-2.76,2.25s-.75-1.53.35-2.38A2.14,2.14,0,0,1,127.45,143.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.41,157.91a6.74,6.74,0,0,1-4.23-1.14s-.28,2.23,1.58,2.66A2.43,2.43,0,0,0,135.41,157.91Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.35,175.79c0,1,.76,4,2.29,3.51s2.58-.94,2.22-2.41-.75-2.53-1.73-2.39S126.35,174.88,126.35,175.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.95,
    cy: 189.82,
    r: 1.64,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.26,
    cy: 188.6,
    r: 1.64,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.02,
    cy: 202.04,
    r: 1.64,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.33,
    cy: 200.82,
    r: 1.64,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.77,
    cy: 213.9,
    r: 1.64,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.08,
    cy: 212.68,
    r: 1.64,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124.8,
    cy: 226.48,
    r: 1.64,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.11,
    cy: 225.26,
    r: 1.64,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.68,
    cy: 238.6,
    r: 1.64,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.99,
    cy: 237.38,
    r: 1.64,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 121.95,
    cy: 189.82,
    r: 1.64
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.26,
    cy: 188.6,
    r: 1.64
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.02,
    cy: 202.04,
    r: 1.64
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.33,
    cy: 200.82,
    r: 1.64
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.77,
    cy: 213.9,
    r: 1.64
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.08,
    cy: 212.68,
    r: 1.64
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.8,
    cy: 226.48,
    r: 1.64
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.11,
    cy: 225.26,
    r: 1.64
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.68,
    cy: 238.6,
    r: 1.64
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.99,
    cy: 237.38,
    r: 1.64
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M62,203.57,239.74,286.8l-1.83,7.7L58.65,210.75a4,4,0,0,1-2.18-4.51h0A4,4,0,0,1,62,203.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.33,173.46a16.45,16.45,0,0,0-11.82,5.39c-5,5.6-16,26.78-16,26.78s4.26,7.69,15,7.66c0,0,10.46-14.86,12.79-19.32S106.85,179.18,102.33,173.46Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.33,173.46a16.45,16.45,0,0,0-11.82,5.39c-5,5.6-16,26.78-16,26.78s4.26,7.69,15,7.66c0,0,10.46-14.86,12.79-19.32S106.85,179.18,102.33,173.46Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.62,210.92s-10.26,16.84,2.94,21.18,35.55,8,35.55,8,.09,6.82,5.34,6.38,10.13-1.37,9.27-4.9L121.23,240s-2.47-2.61-1.52-5.77c0,0,4.12-1.51,4.12-4s-6.78.71-9.88,0-28.26-9.63-28.26-9.63Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.56,205.63s7.31,5.77,15.35,7.08l.64-.86h0a2.8,2.8,0,0,1-.07,2.52l-2.88,5.34a2.37,2.37,0,0,1-2.47,1.23c-3.14-.51-10-2.08-14.53-6.58a2.47,2.47,0,0,1-.43-2.9l3.12-6a1.9,1.9,0,0,1,1.89-1h0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.56,205.63s7.31,5.77,15.35,7.08l.64-.86h0a2.8,2.8,0,0,1-.07,2.52l-2.88,5.34a2.37,2.37,0,0,1-2.47,1.23c-3.14-.51-10-2.08-14.53-6.58a2.47,2.47,0,0,1-.43-2.9l3.12-6a1.9,1.9,0,0,1,1.89-1h0Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.78,252.3a8.67,8.67,0,0,1-.1,3.09,9,9,0,0,0,1,5.48c.67,1-.39,4.28,1.21,4.28s2.69-1.67,2.48-4.07-.46-4.1.51-4.83S174.05,251.64,171.78,252.3Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.78,128.78s-3.35-.09-10.94,1.76c-12.56,3.06-22,15.24-22,15.24l-16.4-39.37A6.79,6.79,0,0,1,98.6,97.3l.49.08a3.86,3.86,0,0,1,.09-.49,9.24,9.24,0,0,1,9.09-7.58,9.1,9.1,0,0,1,4,.91l.44.23A3.87,3.87,0,0,1,113,90a6.68,6.68,0,0,1,3.31-2.65,6.78,6.78,0,0,1,8.73,4Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.78,128.78s-3.35-.09-10.94,1.76c-12.56,3.06-22,15.24-22,15.24l-16.4-39.37A6.79,6.79,0,0,1,98.6,97.3l.49.08a3.86,3.86,0,0,1,.09-.49,9.24,9.24,0,0,1,9.09-7.58,9.1,9.1,0,0,1,4,.91l.44.23A3.87,3.87,0,0,1,113,90a6.68,6.68,0,0,1,3.31-2.65,6.78,6.78,0,0,1,8.73,4Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.54,116.34a35.61,35.61,0,0,0-11.36.52.42.42,0,0,0,0-.33l-11-26.28A.6.6,0,0,0,113,90a3.87,3.87,0,0,0-.27.43l-.44-.23a.55.55,0,0,0,0,.42l11,26.27a.55.55,0,0,0,.12.14,33.72,33.72,0,0,0-12.88,6.28L99.55,97.19a.51.51,0,0,0-.37-.3,3.86,3.86,0,0,0-.09.49l-.49-.08a.43.43,0,0,0,0,.27l11,26.28a.43.43,0,0,0,.09.1,38.42,38.42,0,0,0-7.51,8.31l.47,1.12c2.12-3.42,12.73-18.53,33.32-16Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.23,128.69s2.52-4.62,4.13-2.07S142.07,138,131.9,138a50.46,50.46,0,0,1-12.4-1.29,1.45,1.45,0,0,0-1.81,1.57c.36,3,.47,8.39-2.6,11.51l.45,7.54v4.31s-7.71-1-7.71-15.84A42.39,42.39,0,0,1,139.23,128.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.08,151.5s-1.24-5.55-5.39-5.55-4.08,4.28-3.55,7.13,2.6,5.57,5.36,5.57a3.8,3.8,0,0,0,3.58-2.49Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.32,178.15a.13.13,0,0,0,0-.25.13.13,0,0,0,0,.25Z",
    style: {
      fill: "#272525"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.73,313.73V301.57h-2C440.46,288,429.07,275,410.63,264.7c-47.6-26.59-124.15-25.51-171,2.41-16.66,9.94-27.31,21.93-32,34.46H205v13.52h0c-.6,18.49,11.45,37,36.08,50.74,47.6,26.59,124.15,25.51,171-2.42,22.75-13.56,34.29-31,34.7-48.32h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 325.84,
    cy: 300.67,
    rx: 120.91,
    ry: 69.81,
    transform: "translate(-4.21 4.63) rotate(-0.81)",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pizza--inject-143"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.76,328a4.81,4.81,0,0,1-4.37,0,1.33,1.33,0,0,1,0-2.52,4.81,4.81,0,0,1,4.37,0A1.33,1.33,0,0,1,348.76,328Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.76,328a4.81,4.81,0,0,1-4.37,0,1.33,1.33,0,0,1,0-2.52,4.81,4.81,0,0,1,4.37,0A1.33,1.33,0,0,1,348.76,328Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 325.69,
    cy: 290.5,
    rx: 114.77,
    ry: 66.26,
    transform: "translate(-4.07 4.63) rotate(-0.81)",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 325.69,
    cy: 290.5,
    rx: 114.77,
    ry: 66.26,
    transform: "translate(-4.07 4.63) rotate(-0.81)",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 325.62,
    cy: 285.11,
    rx: 100.79,
    ry: 53.4,
    transform: "translate(-3.99 4.62) rotate(-0.81)",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 325.62,
    cy: 285.11,
    rx: 100.79,
    ry: 53.4,
    transform: "translate(-3.99 4.62) rotate(-0.81)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 325.61,
    cy: 284.48,
    rx: 95.49,
    ry: 50.59,
    transform: "translate(-3.98 4.62) rotate(-0.81)",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 325.61,
    cy: 284.48,
    rx: 95.49,
    ry: 50.59,
    transform: "translate(-3.98 4.62) rotate(-0.81)",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.71,262.46c-7.52,4.34-19.71,4.34-27.23,0s-7.52-11.38,0-15.72,19.71-4.34,27.23,0S312.23,258.12,304.71,262.46Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.71,262.46c-7.52,4.34-19.71,4.34-27.23,0s-7.52-11.38,0-15.72,19.71-4.34,27.23,0S312.23,258.12,304.71,262.46Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 291.09,
    cy: 252.51,
    rx: 19.26,
    ry: 11.12,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 291.09,
    cy: 252.51,
    rx: 19.26,
    ry: 11.12,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 281.87,
    cy: 247.26,
    rx: 2.04,
    ry: 1.18,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 281.87,
    cy: 247.26,
    rx: 2.04,
    ry: 1.18,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.19,258.38a3.16,3.16,0,0,1-2.87,0,.87.87,0,0,1,0-1.66,3.16,3.16,0,0,1,2.87,0A.87.87,0,0,1,294.19,258.38Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.19,258.38a3.16,3.16,0,0,1-2.87,0,.87.87,0,0,1,0-1.66,3.16,3.16,0,0,1,2.87,0A.87.87,0,0,1,294.19,258.38Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.28,251.66a1.84,1.84,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,278.28,251.66Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.28,251.66a1.84,1.84,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,278.28,251.66Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,254.29a1.91,1.91,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,291,254.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,254.29a1.91,1.91,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,291,254.29Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,250.57a1.82,1.82,0,0,1-1.67,0c-.47-.27-.47-.7,0-1a1.82,1.82,0,0,1,1.67,0C295.44,249.87,295.44,250.3,295,250.57Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,250.57a1.82,1.82,0,0,1-1.67,0c-.47-.27-.47-.7,0-1a1.82,1.82,0,0,1,1.67,0C295.44,249.87,295.44,250.3,295,250.57Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.74,257.39a1.84,1.84,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.91,1.91,0,0,1,1.68,0C285.21,256.69,285.21,257.13,284.74,257.39Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.74,257.39a1.84,1.84,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.91,1.91,0,0,1,1.68,0C285.21,256.69,285.21,257.13,284.74,257.39Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 298.54,
    cy: 258.72,
    rx: 1.19,
    ry: 0.69,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 298.54,
    cy: 258.72,
    rx: 1.19,
    ry: 0.69,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.27,248.23a1.91,1.91,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0C303.74,247.53,303.74,248,303.27,248.23Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.27,248.23a1.91,1.91,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0C303.74,247.53,303.74,248,303.27,248.23Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 360.12,
    cy: 255.65,
    rx: 19.26,
    ry: 11.12,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 360.12,
    cy: 255.65,
    rx: 19.26,
    ry: 11.12,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 360.12,
    cy: 253.55,
    rx: 19.26,
    ry: 11.12,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 360.12,
    cy: 253.55,
    rx: 19.26,
    ry: 11.12,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.33,249.14a3.24,3.24,0,0,1-2.88,0,.88.88,0,0,1,0-1.67,3.24,3.24,0,0,1,2.88,0A.88.88,0,0,1,352.33,249.14Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.33,249.14a3.24,3.24,0,0,1-2.88,0,.88.88,0,0,1,0-1.67,3.24,3.24,0,0,1,2.88,0A.88.88,0,0,1,352.33,249.14Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.22,259.43a3.18,3.18,0,0,1-2.88,0,.88.88,0,0,1,0-1.67,3.24,3.24,0,0,1,2.88,0A.88.88,0,0,1,363.22,259.43Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.22,259.43a3.18,3.18,0,0,1-2.88,0,.88.88,0,0,1,0-1.67,3.24,3.24,0,0,1,2.88,0A.88.88,0,0,1,363.22,259.43Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.3,252.71a1.91,1.91,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0C347.77,252,347.77,252.44,347.3,252.71Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.3,252.71a1.91,1.91,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0C347.77,252,347.77,252.44,347.3,252.71Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.06,255.33a1.82,1.82,0,0,1-1.67,0c-.47-.26-.47-.7,0-1a1.89,1.89,0,0,1,1.67,0C360.53,254.63,360.53,255.07,360.06,255.33Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.06,255.33a1.82,1.82,0,0,1-1.67,0c-.47-.26-.47-.7,0-1a1.89,1.89,0,0,1,1.67,0C360.53,254.63,360.53,255.07,360.06,255.33Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,251.62a1.91,1.91,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,364,251.62Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,251.62a1.91,1.91,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,364,251.62Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.77,258.44a1.84,1.84,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,353.77,258.44Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.77,258.44a1.84,1.84,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,353.77,258.44Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.4,260.26a1.91,1.91,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0C368.87,259.55,368.87,260,368.4,260.26Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.4,260.26a1.91,1.91,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0C368.87,259.55,368.87,260,368.4,260.26Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.3,249.27a1.84,1.84,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.91,1.91,0,0,1,1.68,0A.51.51,0,0,1,372.3,249.27Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.3,249.27a1.84,1.84,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.91,1.91,0,0,1,1.68,0A.51.51,0,0,1,372.3,249.27Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 325.61,
    cy: 280.63,
    rx: 19.26,
    ry: 11.12,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 325.61,
    cy: 280.63,
    rx: 19.26,
    ry: 11.12,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 325.61,
    cy: 278.53,
    rx: 19.26,
    ry: 11.12,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 325.61,
    cy: 278.53,
    rx: 19.26,
    ry: 11.12,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.82,274.12a3.18,3.18,0,0,1-2.88,0,.88.88,0,0,1,0-1.66,3.18,3.18,0,0,1,2.88,0A.88.88,0,0,1,317.82,274.12Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.82,274.12a3.18,3.18,0,0,1-2.88,0,.88.88,0,0,1,0-1.66,3.18,3.18,0,0,1,2.88,0A.88.88,0,0,1,317.82,274.12Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.71,284.41a3.18,3.18,0,0,1-2.88,0,.87.87,0,0,1,0-1.66,3.18,3.18,0,0,1,2.88,0A.88.88,0,0,1,328.71,284.41Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.71,284.41a3.18,3.18,0,0,1-2.88,0,.87.87,0,0,1,0-1.66,3.18,3.18,0,0,1,2.88,0A.88.88,0,0,1,328.71,284.41Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.79,277.69a1.84,1.84,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,312.79,277.69Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.79,277.69a1.84,1.84,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,312.79,277.69Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.55,280.31a1.84,1.84,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,325.55,280.31Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.55,280.31a1.84,1.84,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,325.55,280.31Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.49,276.6a1.84,1.84,0,0,1-1.68,0c-.47-.27-.47-.7,0-1a1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,329.49,276.6Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.49,276.6a1.84,1.84,0,0,1-1.68,0c-.47-.27-.47-.7,0-1a1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,329.49,276.6Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.26,283.42a1.84,1.84,0,0,1-1.68,0c-.47-.27-.47-.7,0-1a1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,319.26,283.42Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.26,283.42a1.84,1.84,0,0,1-1.68,0c-.47-.27-.47-.7,0-1a1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,319.26,283.42Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.89,285.24a1.91,1.91,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,333.89,285.24Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.89,285.24a1.91,1.91,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,333.89,285.24Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.78,274.25a1.82,1.82,0,0,1-1.67,0,.5.5,0,0,1,0-1,1.82,1.82,0,0,1,1.67,0A.5.5,0,0,1,337.78,274.25Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.78,274.25a1.82,1.82,0,0,1-1.67,0,.5.5,0,0,1,0-1,1.82,1.82,0,0,1,1.67,0A.5.5,0,0,1,337.78,274.25Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 325.61,
    cy: 316.44,
    rx: 19.26,
    ry: 11.12,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 325.61,
    cy: 316.44,
    rx: 19.26,
    ry: 11.12,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.22,322.21c-7.52,4.34-19.71,4.34-27.23,0s-7.52-11.38,0-15.72,19.71-4.34,27.23,0S346.74,317.87,339.22,322.21Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.22,322.21c-7.52,4.34-19.71,4.34-27.23,0s-7.52-11.38,0-15.72,19.71-4.34,27.23,0S346.74,317.87,339.22,322.21Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.82,309.94a3.21,3.21,0,0,1-2.88,0,.88.88,0,0,1,0-1.66,3.18,3.18,0,0,1,2.88,0A.88.88,0,0,1,317.82,309.94Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.82,309.94a3.21,3.21,0,0,1-2.88,0,.88.88,0,0,1,0-1.66,3.18,3.18,0,0,1,2.88,0A.88.88,0,0,1,317.82,309.94Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.71,320.23a3.24,3.24,0,0,1-2.88,0,.88.88,0,0,1,0-1.67,3.18,3.18,0,0,1,2.88,0A.88.88,0,0,1,328.71,320.23Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.71,320.23a3.24,3.24,0,0,1-2.88,0,.88.88,0,0,1,0-1.67,3.18,3.18,0,0,1,2.88,0A.88.88,0,0,1,328.71,320.23Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.79,313.51a1.91,1.91,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,312.79,313.51Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.79,313.51a1.91,1.91,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,312.79,313.51Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.55,316.13a1.84,1.84,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.91,1.91,0,0,1,1.68,0A.51.51,0,0,1,325.55,316.13Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.55,316.13a1.84,1.84,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.91,1.91,0,0,1,1.68,0A.51.51,0,0,1,325.55,316.13Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.49,312.42a1.91,1.91,0,0,1-1.68,0c-.47-.27-.47-.71,0-1a1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,329.49,312.42Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.49,312.42a1.91,1.91,0,0,1-1.68,0c-.47-.27-.47-.71,0-1a1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,329.49,312.42Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.26,319.24a1.84,1.84,0,0,1-1.68,0c-.47-.27-.47-.7,0-1a1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,319.26,319.24Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.26,319.24a1.84,1.84,0,0,1-1.68,0c-.47-.27-.47-.7,0-1a1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,319.26,319.24Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.89,321.05a1.84,1.84,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,333.89,321.05Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.89,321.05a1.84,1.84,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,333.89,321.05Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.78,310.07a1.82,1.82,0,0,1-1.67,0c-.47-.27-.47-.7,0-1a1.89,1.89,0,0,1,1.67,0C338.25,309.37,338.25,309.8,337.78,310.07Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.78,310.07a1.82,1.82,0,0,1-1.67,0c-.47-.27-.47-.7,0-1a1.89,1.89,0,0,1,1.67,0C338.25,309.37,338.25,309.8,337.78,310.07Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.44,300.41c-7.52,4.34-19.72,4.34-27.24,0s-7.52-11.38,0-15.72,19.72-4.34,27.24,0S286,296.07,278.44,300.41Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.44,300.41c-7.52,4.34-19.72,4.34-27.24,0s-7.52-11.38,0-15.72,19.72-4.34,27.24,0S286,296.07,278.44,300.41Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 264.82,
    cy: 290.46,
    rx: 19.26,
    ry: 11.12,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 264.82,
    cy: 290.46,
    rx: 19.26,
    ry: 11.12,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,286a3.16,3.16,0,0,1-2.87,0,.87.87,0,0,1,0-1.66,3.16,3.16,0,0,1,2.87,0A.87.87,0,0,1,257,286Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,286a3.16,3.16,0,0,1-2.87,0,.87.87,0,0,1,0-1.66,3.16,3.16,0,0,1,2.87,0A.87.87,0,0,1,257,286Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 266.48,
    cy: 295.5,
    rx: 2.04,
    ry: 1.18,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 266.48,
    cy: 295.5,
    rx: 2.04,
    ry: 1.18,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,289.61a1.82,1.82,0,0,1-1.67,0c-.47-.27-.47-.7,0-1a1.82,1.82,0,0,1,1.67,0C252.47,288.91,252.47,289.34,252,289.61Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,289.61a1.82,1.82,0,0,1-1.67,0c-.47-.27-.47-.7,0-1a1.82,1.82,0,0,1,1.67,0C252.47,288.91,252.47,289.34,252,289.61Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.77,292.24a1.91,1.91,0,0,1-1.68,0c-.47-.27-.47-.7,0-1a1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,264.77,292.24Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.77,292.24a1.91,1.91,0,0,1-1.68,0c-.47-.27-.47-.7,0-1a1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,264.77,292.24Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 267.86,
    cy: 288.04,
    rx: 1.19,
    ry: 0.69,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 267.86,
    cy: 288.04,
    rx: 1.19,
    ry: 0.69,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.63,
    cy: 294.86,
    rx: 1.19,
    ry: 0.69,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.63,
    cy: 294.86,
    rx: 1.19,
    ry: 0.69,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.1,297.16a1.82,1.82,0,0,1-1.67,0c-.47-.27-.47-.7,0-1a1.82,1.82,0,0,1,1.67,0C273.57,296.46,273.57,296.89,273.1,297.16Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.1,297.16a1.82,1.82,0,0,1-1.67,0c-.47-.27-.47-.7,0-1a1.82,1.82,0,0,1,1.67,0C273.57,296.46,273.57,296.89,273.1,297.16Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,286.18a1.84,1.84,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,277,286.18Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,286.18a1.84,1.84,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,277,286.18Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,300.41c-7.52,4.34-19.71,4.34-27.23,0s-7.52-11.38,0-15.72,19.71-4.34,27.23,0S407.53,296.07,400,300.41Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,300.41c-7.52,4.34-19.71,4.34-27.23,0s-7.52-11.38,0-15.72,19.71-4.34,27.23,0S407.53,296.07,400,300.41Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 386.39,
    cy: 290.46,
    rx: 19.26,
    ry: 11.12,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 386.39,
    cy: 290.46,
    rx: 19.26,
    ry: 11.12,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.61,286a3.18,3.18,0,0,1-2.88,0,.87.87,0,0,1,0-1.66,3.18,3.18,0,0,1,2.88,0A.88.88,0,0,1,378.61,286Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.61,286a3.18,3.18,0,0,1-2.88,0,.87.87,0,0,1,0-1.66,3.18,3.18,0,0,1,2.88,0A.88.88,0,0,1,378.61,286Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.49,296.33a3.18,3.18,0,0,1-2.88,0,.88.88,0,0,1,0-1.66,3.18,3.18,0,0,1,2.88,0A.87.87,0,0,1,389.49,296.33Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.49,296.33a3.18,3.18,0,0,1-2.88,0,.88.88,0,0,1,0-1.66,3.18,3.18,0,0,1,2.88,0A.87.87,0,0,1,389.49,296.33Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 372.74,
    cy: 289.13,
    rx: 1.19,
    ry: 0.69,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 372.74,
    cy: 289.13,
    rx: 1.19,
    ry: 0.69,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.34,292.24a1.91,1.91,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,386.34,292.24Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.34,292.24a1.91,1.91,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,386.34,292.24Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.27,288.52a1.84,1.84,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0C390.74,287.82,390.74,288.25,390.27,288.52Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.27,288.52a1.84,1.84,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0C390.74,287.82,390.74,288.25,390.27,288.52Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,295.34a1.84,1.84,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,380,295.34Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,295.34a1.84,1.84,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,380,295.34Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.68,297.16a1.84,1.84,0,0,1-1.68,0c-.47-.27-.47-.7,0-1a1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,394.68,297.16Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.68,297.16a1.84,1.84,0,0,1-1.68,0c-.47-.27-.47-.7,0-1a1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,394.68,297.16Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.57,286.18a1.84,1.84,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,398.57,286.18Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.57,286.18a1.84,1.84,0,0,1-1.68,0,.51.51,0,0,1,0-1,1.84,1.84,0,0,1,1.68,0A.51.51,0,0,1,398.57,286.18Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.54,306.74a10.65,10.65,0,0,1-5.24-1.28,4.2,4.2,0,0,1,0-7.77,11.41,11.41,0,0,1,10.48,0,4.2,4.2,0,0,1,0,7.77h0A10.67,10.67,0,0,1,298.54,306.74Zm0-7.33a7.74,7.74,0,0,0-3.74.87c-.69.4-1.11.89-1.11,1.29s.42.9,1.11,1.3a8.47,8.47,0,0,0,7.48,0h0c.69-.4,1.1-.89,1.1-1.3s-.41-.89-1.1-1.29A7.77,7.77,0,0,0,298.54,299.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.33,306.38a10.63,10.63,0,0,1-5.23-1.27,4.2,4.2,0,0,1,0-7.78,11.44,11.44,0,0,1,10.47,0,4.2,4.2,0,0,1,0,7.78h0A10.64,10.64,0,0,1,351.33,306.38Zm0-7.33a7.7,7.7,0,0,0-3.73.88c-.7.4-1.11.88-1.11,1.29s.41.89,1.11,1.29a8.39,8.39,0,0,0,7.47,0h0c.69-.4,1.11-.88,1.11-1.29s-.42-.89-1.11-1.29A7.71,7.71,0,0,0,351.33,299.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.85,263.2a10.64,10.64,0,0,1-5.24-1.27,4.2,4.2,0,0,1,0-7.78,11.41,11.41,0,0,1,10.48,0,4.21,4.21,0,0,1,0,7.78h0A10.67,10.67,0,0,1,390.85,263.2Zm0-7.33a7.63,7.63,0,0,0-3.74.88c-.69.4-1.11.88-1.11,1.29s.42.89,1.11,1.29a8.41,8.41,0,0,0,7.48,0h0c.69-.4,1.1-.88,1.1-1.29s-.41-.89-1.1-1.29A7.66,7.66,0,0,0,390.85,255.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.15,278.85a6.87,6.87,0,0,1,2.9,2.9c.74,1.6,4.22,2.15,6.24,1l.21-.12c4-2.45,4-6.37.07-8.83-4.35-2.71-11.67-2.77-16.15-.18l-.05,0c-2,1.16-1,3.14,1.77,3.56A14.52,14.52,0,0,1,359.15,278.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,278.83l-1.89-1.09-1.89-1.09-8.1,3.09c-1.17.44-1.33,1.39-.34,2l1.73,1,1.73,1a3.34,3.34,0,0,0,3.41-.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.15,277.08a6.8,6.8,0,0,1,2.9,2.89c.74,1.6,4.22,2.16,6.24,1l.21-.12c4-2.44,4-6.37.07-8.83-4.35-2.71-11.67-2.77-16.15-.18l-.05,0c-2,1.16-1,3.14,1.77,3.56A14.52,14.52,0,0,1,359.15,277.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,277.05,361.09,276l-1.89-1.09L351.1,278c-1.17.45-1.33,1.4-.34,2l1.73,1,1.73,1a3.34,3.34,0,0,0,3.41-.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.15,294.4a6.79,6.79,0,0,1,2.89,2.9c.74,1.6,4.22,2.15,6.24,1l.21-.13c4-2.44,4-6.36.07-8.82-4.35-2.71-11.67-2.77-16.15-.19l-.05,0c-2,1.16-1,3.14,1.77,3.56A14.57,14.57,0,0,1,326.15,294.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,294.38l-1.89-1.09-1.89-1.1-8.1,3.1c-1.17.44-1.33,1.39-.34,2l1.73,1,1.73,1a3.32,3.32,0,0,0,3.41-.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.15,292.63a6.77,6.77,0,0,1,2.89,2.89c.74,1.6,4.22,2.16,6.24,1l.21-.12c4-2.44,4-6.37.07-8.83-4.35-2.71-11.67-2.77-16.15-.18l-.05,0c-2,1.16-1,3.14,1.77,3.56A14.37,14.37,0,0,1,326.15,292.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,292.6l-1.89-1.09-1.89-1.09-8.1,3.09c-1.17.45-1.33,1.4-.34,2l1.73,1,1.73,1a3.34,3.34,0,0,0,3.41-.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,278.85a6.84,6.84,0,0,0-2.89,2.9c-.74,1.6-4.22,2.15-6.24,1l-.21-.12c-4-2.45-4-6.37-.07-8.83,4.34-2.71,11.67-2.77,16.15-.18l.05,0c2,1.16,1,3.14-1.77,3.56A14.5,14.5,0,0,0,293,278.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.22,278.83l1.89-1.09,1.89-1.09,8.1,3.09c1.16.44,1.33,1.39.34,2l-1.73,1-1.73,1a3.34,3.34,0,0,1-3.41-.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,277.08a6.77,6.77,0,0,0-2.89,2.89c-.74,1.6-4.22,2.16-6.24,1l-.21-.12c-4-2.44-4-6.37-.07-8.83,4.34-2.71,11.67-2.77,16.15-.18l.05,0c2,1.16,1,3.14-1.77,3.56A14.5,14.5,0,0,0,293,277.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.22,277.05l1.89-1.09,1.89-1.09,8.1,3.09c1.16.45,1.33,1.4.34,2l-1.73,1-1.73,1a3.34,3.34,0,0,1-3.41-.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.56,273.49a6.77,6.77,0,0,1,2.89,2.89c.74,1.6,4.22,2.16,6.24,1l.21-.13c4-2.44,4-6.36.07-8.83-4.34-2.7-11.67-2.76-16.15-.18l-.05,0c-2,1.16-1,3.14,1.77,3.56A14.5,14.5,0,0,1,400.56,273.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.39,273.47l-1.9-1.1-1.89-1.09-8.1,3.09c-1.16.45-1.33,1.4-.34,2l1.73,1,1.74,1a3.3,3.3,0,0,0,3.4-.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.56,271.72a6.77,6.77,0,0,1,2.89,2.89c.74,1.6,4.22,2.16,6.24,1l.21-.12c4-2.45,4-6.37.07-8.83-4.34-2.71-11.67-2.77-16.15-.18l-.05,0c-2,1.16-1,3.13,1.77,3.55A14.51,14.51,0,0,1,400.56,271.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.39,271.69l-1.9-1.09-1.89-1.09-8.1,3.09c-1.16.44-1.33,1.39-.34,2l1.73,1,1.74,1a3.32,3.32,0,0,0,3.4-.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.78,261.93h0a4.2,4.2,0,0,1,0-7.78,11.38,11.38,0,0,1,10.47,0,4.2,4.2,0,0,1,0,7.78,11.42,11.42,0,0,1-10.47,0Zm1.5-5.18c-.7.4-1.11.88-1.11,1.29s.41.89,1.11,1.29h0a8.39,8.39,0,0,0,7.47,0c.69-.4,1.11-.88,1.11-1.29s-.42-.89-1.11-1.29a8.37,8.37,0,0,0-7.47,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.3,273.49a6.77,6.77,0,0,0-2.89,2.89c-.74,1.6-4.22,2.16-6.24,1l-.21-.13c-4-2.44-4-6.36-.07-8.83,4.34-2.7,11.67-2.76,16.15-.18l0,0c2,1.16,1,3.14-1.77,3.56A14.5,14.5,0,0,0,253.3,273.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.48,273.47l1.89-1.1,1.89-1.09,8.1,3.09c1.16.45,1.33,1.4.34,2l-1.73,1-1.74,1a3.3,3.3,0,0,1-3.4-.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.3,271.72a6.77,6.77,0,0,0-2.89,2.89c-.74,1.6-4.22,2.16-6.24,1l-.21-.12c-4-2.45-4-6.37-.07-8.83,4.34-2.71,11.67-2.77,16.15-.18l0,0c2,1.16,1,3.13-1.77,3.55A14.51,14.51,0,0,0,253.3,271.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.48,271.69l1.89-1.09,1.89-1.09,8.1,3.09c1.16.44,1.33,1.39.34,2l-1.73,1-1.74,1a3.32,3.32,0,0,1-3.4-.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.68,312.55a6.84,6.84,0,0,0,2.89-2.9c.74-1.6,4.22-2.15,6.24-1l.21.12c4,2.45,4,6.37.07,8.83-4.34,2.71-11.67,2.77-16.15.18l-.05,0c-2-1.16-1-3.14,1.77-3.56A14.79,14.79,0,0,0,372.68,312.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.5,312.57l-1.89,1.09-1.89,1.09-8.1-3.09c-1.16-.44-1.33-1.39-.34-2l1.73-1,1.73-1a3.34,3.34,0,0,1,3.41.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.68,310.77a6.77,6.77,0,0,0,2.89-2.89c.74-1.6,4.22-2.16,6.24-1l.21.13c4,2.44,4,6.36.07,8.83-4.34,2.7-11.67,2.77-16.15.18l-.05,0c-2-1.16-1-3.14,1.77-3.56A14.57,14.57,0,0,0,372.68,310.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.5,310.79l-1.89,1.1L372.72,313l-8.1-3.09c-1.16-.45-1.33-1.4-.34-2l1.73-1,1.73-1a3.34,3.34,0,0,1,3.41.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.74,274.26c5,2.9,15.28,1.67,15.28,1.67s2.13-5.93-2.88-8.83-15.3-1.67-15.3-1.67S371.71,271.36,376.74,274.26Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.74,274.26c5,2.9,15.28,1.67,15.28,1.67s2.13-5.93-2.88-8.83-15.3-1.67-15.3-1.67S371.71,271.36,376.74,274.26Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.74,274.26c5,2.9,15.28,1.67,15.28,1.67l-18.18-10.5S371.71,271.36,376.74,274.26Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.74,274.26c5,2.9,15.28,1.67,15.28,1.67l-18.18-10.5S371.71,271.36,376.74,274.26Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.05,274.26c-5,2.9-15.28,1.67-15.28,1.67s-2.13-5.93,2.88-8.83,15.3-1.67,15.3-1.67S282.08,271.36,277.05,274.26Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.05,274.26c-5,2.9-15.28,1.67-15.28,1.67s-2.13-5.93,2.88-8.83,15.3-1.67,15.3-1.67S282.08,271.36,277.05,274.26Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.05,274.26c-5,2.9-15.28,1.67-15.28,1.67L280,265.43S282.08,271.36,277.05,274.26Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.05,274.26c-5,2.9-15.28,1.67-15.28,1.67L280,265.43S282.08,271.36,277.05,274.26Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.33,295.64c5,2.89,15.28,1.66,15.28,1.66s2.13-5.93-2.88-8.82-15.3-1.67-15.3-1.67S343.3,292.74,348.33,295.64Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.33,295.64c5,2.89,15.28,1.66,15.28,1.66s2.13-5.93-2.88-8.82-15.3-1.67-15.3-1.67S343.3,292.74,348.33,295.64Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.33,295.64c5,2.89,15.28,1.66,15.28,1.66l-18.18-10.49S343.3,292.74,348.33,295.64Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.33,295.64c5,2.89,15.28,1.66,15.28,1.66l-18.18-10.49S343.3,292.74,348.33,295.64Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.74,295.64c-5,2.89-15.29,1.66-15.29,1.66s-2.13-5.93,2.88-8.82,15.3-1.67,15.3-1.67S309.76,292.74,304.74,295.64Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.74,295.64c-5,2.89-15.29,1.66-15.29,1.66s-2.13-5.93,2.88-8.82,15.3-1.67,15.3-1.67S309.76,292.74,304.74,295.64Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.74,295.64c-5,2.89-15.29,1.66-15.29,1.66l18.18-10.49S309.76,292.74,304.74,295.64Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.74,295.64c-5,2.89-15.29,1.66-15.29,1.66l18.18-10.49S309.76,292.74,304.74,295.64Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.16,246c-5,2.89-15.29,1.66-15.29,1.66s-2.13-5.93,2.88-8.82,15.3-1.67,15.3-1.67S334.18,243.12,329.16,246Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.16,246c-5,2.89-15.29,1.66-15.29,1.66s-2.13-5.93,2.88-8.82,15.3-1.67,15.3-1.67S334.18,243.12,329.16,246Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.16,246c-5,2.89-15.29,1.66-15.29,1.66l18.18-10.49S334.18,243.12,329.16,246Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.16,246c-5,2.89-15.29,1.66-15.29,1.66l18.18-10.49S334.18,243.12,329.16,246Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.55,322.34c5,2.89,15.28,1.66,15.28,1.66s2.13-5.93-2.88-8.82-15.29-1.67-15.29-1.67S348.52,319.44,353.55,322.34Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.55,322.34c5,2.89,15.28,1.66,15.28,1.66s2.13-5.93-2.88-8.82-15.29-1.67-15.29-1.67S348.52,319.44,353.55,322.34Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.55,322.34c5,2.89,15.28,1.66,15.28,1.66l-18.17-10.49S348.52,319.44,353.55,322.34Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.55,322.34c5,2.89,15.28,1.66,15.28,1.66l-18.17-10.49S348.52,319.44,353.55,322.34Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.57,315.51c5,2.9,15.28,1.67,15.28,1.67s2.14-5.93-2.88-8.83-15.29-1.67-15.29-1.67S256.55,312.61,261.57,315.51Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.57,315.51c5,2.9,15.28,1.67,15.28,1.67s2.14-5.93-2.88-8.83-15.29-1.67-15.29-1.67S256.55,312.61,261.57,315.51Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.57,315.51c5,2.9,15.28,1.67,15.28,1.67l-18.17-10.5S256.55,312.61,261.57,315.51Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.57,315.51c5,2.9,15.28,1.67,15.28,1.67l-18.17-10.5S256.55,312.61,261.57,315.51Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.61,264.57a10.64,10.64,0,0,1-5.24-1.27,4.2,4.2,0,0,1,0-7.78,11.38,11.38,0,0,1,10.47,0,4.2,4.2,0,0,1,0,7.78h0A10.63,10.63,0,0,1,325.61,264.57Zm0-7.33a7.6,7.6,0,0,0-3.74.88c-.69.4-1.11.88-1.11,1.29s.42.89,1.11,1.29a8.39,8.39,0,0,0,7.47,0h0c.7-.4,1.11-.88,1.11-1.29s-.41-.89-1.11-1.29A7.59,7.59,0,0,0,325.61,257.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,315.54a6.82,6.82,0,0,1-2.9-2.9c-.74-1.6-4.21-2.15-6.24-1a1.37,1.37,0,0,0-.2.13c-4,2.44-4,6.36-.08,8.82,4.35,2.71,11.68,2.77,16.16.19l.05,0c2-1.16.95-3.14-1.77-3.56A14.5,14.5,0,0,1,287,315.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.13,315.56l1.89,1.09,1.9,1.1,8.09-3.1c1.17-.44,1.34-1.39.35-2l-1.73-1-1.74-1a3.3,3.3,0,0,0-3.4.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,313.76a6.8,6.8,0,0,1-2.9-2.89c-.74-1.6-4.21-2.16-6.24-1l-.2.12c-4,2.44-4,6.37-.08,8.83,4.35,2.71,11.68,2.77,16.16.18l.05,0c2-1.16.95-3.14-1.77-3.56A14.5,14.5,0,0,1,287,313.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.13,313.79l1.89,1.09,1.9,1.09,8.09-3.09c1.17-.45,1.34-1.4.35-2l-1.73-1-1.74-1a3.32,3.32,0,0,0-3.4.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.07,248.15a6.8,6.8,0,0,0-2.9,2.89c-.74,1.6-4.21,2.16-6.24,1l-.2-.12c-4-2.44-4-6.37-.08-8.83,4.35-2.71,11.68-2.77,16.16-.18l.05,0c2,1.16.95,3.14-1.77,3.56A14.5,14.5,0,0,0,330.07,248.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.24,248.12l1.89-1.09,1.89-1.09,8.1,3.09c1.17.45,1.34,1.4.35,2l-1.74,1L335,253a3.32,3.32,0,0,1-3.4-.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.07,246.37a6.82,6.82,0,0,0-2.9,2.9c-.74,1.6-4.21,2.15-6.24,1a1.37,1.37,0,0,1-.2-.13c-4-2.44-4-6.36-.08-8.82,4.35-2.71,11.68-2.77,16.16-.19l.05,0c2,1.16.95,3.14-1.77,3.56A14.5,14.5,0,0,0,330.07,246.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.24,246.35l1.89-1.09,1.89-1.1,8.1,3.1c1.17.44,1.34,1.39.35,2l-1.74,1-1.73,1a3.3,3.3,0,0,1-3.4-.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.47,269.19l-5-.64c.45-2.63-1.07-5.34-4.55-7.35a22,22,0,0,0-9.6-2.63v-3.29a28.06,28.06,0,0,1,14.28,3.22C349.57,261.39,351.2,265.5,349.47,269.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.44,308l-5-.64c.44-2.63-1.08-5.34-4.56-7.35a22,22,0,0,0-9.6-2.63v-3.29a28,28,0,0,1,14.28,3.22C400.54,300.24,402.17,304.35,400.44,308Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.3,299.87l5-.65c-.44-2.62,1.08-5.34,4.56-7.35a22,22,0,0,1,9.6-2.62V286a28,28,0,0,0-14.28,3.21C240.2,292.07,238.57,296.18,240.3,299.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.81,326.78l5.05-.65c-.45-2.62,1.07-5.34,4.55-7.35a22,22,0,0,1,9.6-2.62v-3.29a28.05,28.05,0,0,0-14.28,3.21C300.71,319,299.08,323.09,300.81,326.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.16,291l5-.65c-.44-2.62,1.07-5.34,4.55-7.35a22,22,0,0,1,9.6-2.62v-3.29a27.89,27.89,0,0,0-14.27,3.21C304.06,283.24,302.43,287.34,304.16,291Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.74,251.12l5.05-.64c-.45-2.63,1.07-5.34,4.55-7.35a22,22,0,0,1,9.6-2.63v-3.29a28,28,0,0,0-14.28,3.22C286.64,243.32,285,247.43,286.74,251.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.67,240.48a4.81,4.81,0,0,1-4.37,0,1.33,1.33,0,0,1,0-2.52,4.81,4.81,0,0,1,4.37,0A1.33,1.33,0,0,1,345.67,240.48Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.67,240.48a4.81,4.81,0,0,1-4.37,0,1.33,1.33,0,0,1,0-2.52,4.81,4.81,0,0,1,4.37,0A1.33,1.33,0,0,1,345.67,240.48Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,266.7a4.87,4.87,0,0,1-4.37,0,1.34,1.34,0,0,1,0-2.53,4.87,4.87,0,0,1,4.37,0A1.34,1.34,0,0,1,340,266.7Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,266.7a4.87,4.87,0,0,1-4.37,0,1.34,1.34,0,0,1,0-2.53,4.87,4.87,0,0,1,4.37,0A1.34,1.34,0,0,1,340,266.7Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.26,267a4.87,4.87,0,0,1-4.37,0,1.33,1.33,0,0,1,0-2.52,4.81,4.81,0,0,1,4.37,0A1.33,1.33,0,0,1,310.26,267Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.26,267a4.87,4.87,0,0,1-4.37,0,1.33,1.33,0,0,1,0-2.52,4.81,4.81,0,0,1,4.37,0A1.33,1.33,0,0,1,310.26,267Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.82,283.56a4.81,4.81,0,0,1-4.37,0,1.33,1.33,0,0,1,0-2.52,4.81,4.81,0,0,1,4.37,0A1.33,1.33,0,0,1,241.82,283.56Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.82,283.56a4.81,4.81,0,0,1-4.37,0,1.33,1.33,0,0,1,0-2.52,4.81,4.81,0,0,1,4.37,0A1.33,1.33,0,0,1,241.82,283.56Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.22,307.53a4.87,4.87,0,0,1-4.37,0,1.33,1.33,0,0,1,0-2.52,4.81,4.81,0,0,1,4.37,0A1.33,1.33,0,0,1,253.22,307.53Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.22,307.53a4.87,4.87,0,0,1-4.37,0,1.33,1.33,0,0,1,0-2.52,4.81,4.81,0,0,1,4.37,0A1.33,1.33,0,0,1,253.22,307.53Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.77,300.17a4.87,4.87,0,0,1-4.37,0,1.33,1.33,0,0,1,0-2.52,4.81,4.81,0,0,1,4.37,0A1.33,1.33,0,0,1,314.77,300.17Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.77,300.17a4.87,4.87,0,0,1-4.37,0,1.33,1.33,0,0,1,0-2.52,4.81,4.81,0,0,1,4.37,0A1.33,1.33,0,0,1,314.77,300.17Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,285.3a4.87,4.87,0,0,1-4.37,0,1.34,1.34,0,0,1,0-2.53,4.87,4.87,0,0,1,4.37,0A1.34,1.34,0,0,1,412,285.3Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,285.3a4.87,4.87,0,0,1-4.37,0,1.34,1.34,0,0,1,0-2.53,4.87,4.87,0,0,1,4.37,0A1.34,1.34,0,0,1,412,285.3Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.7,314.51a4.81,4.81,0,0,1-4.37,0,1.33,1.33,0,0,1,0-2.52,4.81,4.81,0,0,1,4.37,0A1.33,1.33,0,0,1,393.7,314.51Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.7,314.51a4.81,4.81,0,0,1-4.37,0,1.33,1.33,0,0,1,0-2.52,4.81,4.81,0,0,1,4.37,0A1.33,1.33,0,0,1,393.7,314.51Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.5,250.38a4.81,4.81,0,0,1-4.37,0,1.33,1.33,0,0,1,0-2.52,4.81,4.81,0,0,1,4.37,0A1.33,1.33,0,0,1,386.5,250.38Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.5,250.38a4.81,4.81,0,0,1-4.37,0,1.33,1.33,0,0,1,0-2.52,4.81,4.81,0,0,1,4.37,0A1.33,1.33,0,0,1,386.5,250.38Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.26,305.74a4.81,4.81,0,0,1-4.37,0,1.33,1.33,0,0,1,0-2.52,4.87,4.87,0,0,1,4.37,0A1.33,1.33,0,0,1,286.26,305.74Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.26,305.74a4.81,4.81,0,0,1-4.37,0,1.33,1.33,0,0,1,0-2.52,4.87,4.87,0,0,1,4.37,0A1.33,1.33,0,0,1,286.26,305.74Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.13,302.84a4.87,4.87,0,0,1-4.37,0,1.34,1.34,0,0,1,0-2.53,4.87,4.87,0,0,1,4.37,0A1.34,1.34,0,0,1,339.13,302.84Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.13,302.84a4.87,4.87,0,0,1-4.37,0,1.34,1.34,0,0,1,0-2.53,4.87,4.87,0,0,1,4.37,0A1.34,1.34,0,0,1,339.13,302.84Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.13,328a4.81,4.81,0,0,1-4.37,0,1.33,1.33,0,0,1,0-2.52,4.81,4.81,0,0,1,4.37,0A1.33,1.33,0,0,1,295.13,328Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.13,328a4.81,4.81,0,0,1-4.37,0,1.33,1.33,0,0,1,0-2.52,4.81,4.81,0,0,1,4.37,0A1.33,1.33,0,0,1,295.13,328Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Oven--inject-143"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.73,77.9C350.61,61.09,327,74.71,327,108.33a90.36,90.36,0,0,0,4,25.44l97.52,56.3c2.54-5.67,3.95-12.67,3.95-20.86C432.44,135.59,408.84,94.71,379.73,77.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.73,77.9C350.61,61.09,327,74.71,327,108.33a79.53,79.53,0,0,0,.46,8.24l59.16-34.15A77,77,0,0,0,379.73,77.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.71,126.13a90.68,90.68,0,0,1-3.95-25.43c0-12.56,3.29-22.33,8.93-28.76C335.12,75.81,327,88.63,327,108.33a90.36,90.36,0,0,0,4,25.44Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.31,199.07a.43.43,0,0,1-.22-.06L318,126.8a.45.45,0,0,1-.16-.61.44.44,0,0,1,.6-.16l125.08,72.22a.44.44,0,0,1-.22.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.69,190.7l-98.1-56.64,0-.17a90.86,90.86,0,0,1-4-25.56c0-16.42,5.56-28.68,15.66-34.51S365.72,69.3,380,77.51c29.19,16.86,52.93,58,52.93,91.7,0,8-1.34,15.14-4,21Zm-97.35-57.23,96.94,56A50.8,50.8,0,0,0,432,169.21c0-33.43-23.55-74.22-52.49-90.93-13.94-8-27-9.36-36.84-3.7s-15.22,17.66-15.22,33.75A89.6,89.6,0,0,0,331.34,133.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,149a.43.43,0,0,1-.44-.44V133.77a.43.43,0,0,1,.44-.44.44.44,0,0,1,.44.44v14.74A.44.44,0,0,1,331,149Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.9,163.22a.44.44,0,0,1-.44-.44V148a.44.44,0,0,1,.44-.44.44.44,0,0,1,.44.44v14.75A.44.44,0,0,1,355.9,163.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.82,177.44a.44.44,0,0,1-.44-.44V162.25a.44.44,0,1,1,.88,0V177A.44.44,0,0,1,379.82,177.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.74,191.24a.44.44,0,0,1-.44-.44V176.05a.44.44,0,0,1,.88,0V190.8A.44.44,0,0,1,403.74,191.24Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.49,205.26a.44.44,0,0,1-.44-.44V190.07a.44.44,0,0,1,.88,0v14.75A.44.44,0,0,1,428.49,205.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.87,71.48a.44.44,0,0,1-.44-.44V54.62a.44.44,0,0,1,.88,0V71A.44.44,0,0,1,362.87,71.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.7,82.9a.46.46,0,0,1-.2-.05.45.45,0,0,1-.19-.6l7.55-14.57a.44.44,0,0,1,.6-.19.43.43,0,0,1,.18.59l-7.55,14.58A.44.44,0,0,1,387.7,82.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.2,76.14a.43.43,0,0,1-.42-.3L334.69,63a.44.44,0,0,1,.29-.55.43.43,0,0,1,.55.29l4.09,12.87a.44.44,0,0,1-.29.55A.32.32,0,0,1,339.2,76.14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.84,90.23a.48.48,0,0,1-.31-.13l-9.73-9.36a.45.45,0,0,1,0-.63.44.44,0,0,1,.62,0l9.74,9.37a.44.44,0,0,1,0,.62A.45.45,0,0,1,328.84,90.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.54,110.34a.39.39,0,0,1-.23-.07l-11.52-7a.44.44,0,1,1,.45-.75l11.53,7a.45.45,0,0,1,.15.61A.47.47,0,0,1,326.54,110.34Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.94,105.46a.44.44,0,0,1-.35-.17.44.44,0,0,1,.08-.62l13-10a.42.42,0,0,1,.61.08.43.43,0,0,1-.07.61l-13,10.06A.46.46,0,0,1,409.94,105.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,134.21a.43.43,0,0,1-.4-.27.44.44,0,0,1,.23-.58l15.08-6.5a.44.44,0,0,1,.57.23.43.43,0,0,1-.23.58l-15.07,6.5A.39.39,0,0,1,426,134.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.85,164.88h0l-16.41-.75a.44.44,0,0,1-.42-.46.45.45,0,0,1,.46-.42l16.41.75a.44.44,0,0,1,0,.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,210.6l-.33-.19-116-67-.06-.19c-3.48-11.78-5.1-31.54-5.1-41.2,0-19.41,6.49-33.87,18.78-41.8,12.92-8.34,31-8.28,49.67.15h0c35.4,16,70.13,68,65.41,119.93-1.81,20-12,29.92-12.1,30ZM321.49,142.77l115.32,66.58c1.58-1.68,9.92-11.31,11.54-29.12C453,128.73,418.6,77.16,383.52,61.3h0c-18.33-8.29-36.09-8.37-48.72-.22-12,7.74-18.32,21.9-18.32,41C316.48,112,318.22,131.56,321.49,142.77Z",
    style: {
      fill: "#ebebeb"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPizza);
export default __webpack_public_path__ + "static/media/pizza.7b28b1fe52caa26520f3b69b6de6e23c.svg";
export { ForwardRef as ReactComponent };